import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import Amplitude from "@Shared/utils/amplitude";
import { getMainApi } from "@Shared/utils/ajax";
import TimelineEmailContactList from "./timeline-email-contact-list";
import ActivityConvertButton from "./convert-to-activity/activity-convert-button";
import RichTextEditor from "@Shared/utils/rich-text-editor";
import SpinnerLoader from "@Shared/utils/preload";
import { openFileDialog } from "../../../../../../../../shared/utils/utils";
import { DELETE_EMAIL, MOVE_EMAIL_ATTACHMENT, LOAD_EMAIL_BODY } from "@Broker/@Modules/clients/board/store/board-actions";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { showToast } from "@Shared/utils/constants";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import Err from "@Broker/@Routes/error";
import { SYNCED_EMAILS_LIST } from "@Broker/@Modules/settings/store/settings-getters";
import { chain, isEmpty, uniq } from "lodash";
import UploadFilesModal from "@Broker/@Modules/util-components/upload-files-modal/upload-files-modal.vue";
import { UPLOAD_DOCUMENT_TO_CLASSIFICATION } from "@Broker/js/modules/clients/applications/documents/store/documents-actions";
import { getFileName } from "@Broker/js/custom/utils";
import { ADD_TIMELINE_ITEM } from "../../../store/board-mutations";
import { validate as uuidValidate } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineEmail",
  components: {
    TimelineEmailContactList,
    ActivityConvertButton,
    InlinePrompt,
    UploadFilesModal
  },
  props: {
    threadEmails: {
      type: Array,
      default: () => []
    },
    timelineList: {
      type: Array,
      default: () => []
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    applications: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showEmailCC: false,
      fileUploadInfo: {
        applicationId: null,
        files: [],
        selectedFiles: [],
        selectedClassification: {},
        uploading: false,
        uploadingSucceeded: true
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("SettingsStore", [SYNCED_EMAILS_LIST])), {}, {
    threadParticipants() {
      var _context, _context2;
      return uniq(_flatInstanceProperty(_context = _mapInstanceProperty(_context2 = this.threadEmails).call(_context2, thread => {
        var _context3, _context4, _context5;
        const toList = _mapInstanceProperty(_context3 = thread.toList.list).call(_context3, ({
          email
        }) => email);
        const ccList = _mapInstanceProperty(_context4 = thread.ccList.list).call(_context4, ({
          email
        }) => email);
        const bcList = _mapInstanceProperty(_context5 = thread.bccList.list).call(_context5, ({
          email
        }) => email);
        return [thread.fromEmail, ...toList, ...ccList, ...bcList];
      })).call(_context));
    },
    isCurrentUserInThread() {
      const syncedEmails = this.SYNCED_EMAILS_LIST;
      return syncedEmails == null ? void 0 : syncedEmails.some(email => this.threadParticipants.some(participantEmail => _trimInstanceProperty(email).call(email).toLowerCase() === _trimInstanceProperty(participantEmail).call(participantEmail).toLowerCase()));
    },
    replyAllTooltipText() {
      if (!this.isCurrentUserInThread) return this.$t("client-profile.messages.youCantReplyToThisThread");
      return this.$t("email.actions.replyAll");
    }
  }),
  mounted() {
    this.checkThreadId();
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("BoardStore", [DELETE_EMAIL, MOVE_EMAIL_ATTACHMENT, LOAD_EMAIL_BODY])), mapActions("DocumentsStore", [UPLOAD_DOCUMENT_TO_CLASSIFICATION])), mapMutations("BoardStore", [ADD_TIMELINE_ITEM])), {}, {
    firstItem(idx) {
      return idx === 0;
    },
    timelineEmail(emailId, threadId, messageId) {
      var _context6, _context7, _context8, _context9;
      return _findInstanceProperty(_context6 = _mapInstanceProperty(_context7 = _filterInstanceProperty(_context8 = _mapInstanceProperty(_context9 = chain(this.timelineList)).call(_context9, "items").flatten()).call(_context8, {
        activityType: "email",
        threadId
      })).call(_context7, "threadEmails").flatten()).call(_context6, i => i.messageId === messageId && i.id === emailId).value();
    },
    hasFiles(filesList) {
      var _filesList$files;
      return (filesList == null ? void 0 : (_filesList$files = filesList.files) == null ? void 0 : _filterInstanceProperty(_filesList$files).call(_filesList$files, file => file.filename).length) > 0;
    },
    async getEmailAttachment(emailId, documentId, fileName) {
      return getMainApi({
        fileName
      }, `/client/profile/${this.clientProfileId}/email/${emailId}/file/${documentId}`);
    },
    async downloadFile(emailId, documentId, filename, event) {
      event.stopPropagation();
      const target = $(event.currentTarget);
      try {
        target.animateButton().animate("start");
        const {
          signedFileOptions
        } = await this.getEmailAttachment(emailId, documentId, filename);
        openFileDialog(signedFileOptions.url, filename);
        target.animateButton().animate("finish");
      } catch (error) {
        target.animateButton().animate("finish", "failed");
      }
    },
    async loadEmailIntoHTML(htmlString, target) {
      SpinnerLoader.start(target);
      return new _Promise(resolve => {
        window.requestAnimationFrame(() => {
          try {
            const htmlNode = document.createElement("html");
            htmlNode.innerHTML = RichTextEditor.sanitizeHtml(htmlString);
            htmlNode.querySelectorAll("base").forEach(meta => {
              meta.remove();
            });
            htmlNode.querySelectorAll("a").forEach(anchor => {
              anchor.target = "_blank";
            });
            const iframe = $("<iframe class='email-iframe' frameborder='0' width='100%' height='100%'>")[0];
            target.prepend(iframe);
            const iframeDocument = iframe.contentWindow.document;
            iframeDocument.open();
            iframeDocument.write(htmlNode.innerHTML);
            iframeDocument.close();
            resolve();
            SpinnerLoader.stop(target);
          } catch (e) {
            Amplitude.logHandledError(e);
            SpinnerLoader.start(target, {
              error: true
            });
            resolve();
          }
        });
      });
    },
    async prepareEmail(emailId, threadId, messageId, card) {
      const targetContainer = $(`#email-${emailId}`);
      if (_findInstanceProperty(targetContainer).call(targetContainer, "iframe").exists()) return;
      const email = this.timelineEmail(emailId, threadId, messageId);
      const {
        filesList: {
          files
        }
      } = email;
      let {
        body
      } = email;
      if (!card.hasClass("card-closed") && isEmpty(body)) {
        card.toggleClass("disabled");
        await this.LOAD_EMAIL_BODY({
          emailId,
          clientProfileId: this.clientProfileId
        });
        body = this.timelineEmail(emailId, threadId, messageId).body;
        card.toggleClass("disabled");
      }
      if (files) {
        files.forEach(file => {
          body = _replaceAllInstanceProperty(body).call(body, "cid:" + file.content_id, file.displayUrl);
        });
      }
      return await this.loadEmailIntoHTML(body, targetContainer);
    },
    resizeIframe(iframeNode) {
      let height = 0;
      try {
        // Try to get the height of the body inside the iframe
        height = iframeNode.contentWindow.document.body.scrollHeight;
      } catch (error) {
        // If there's an error, fallback to the documentElement's scrollHeight
        height = iframeNode.contentWindow.document.documentElement.scrollHeight;
      }
      $(iframeNode).css("height", height + 20 + "px");
    },
    async handleIframe(emailId, threadId, messageId, event) {
      const card = $(event.currentTarget).closest(".email-card");
      await this.prepareEmail(emailId, threadId, messageId, card);
      const cardBody = card.children(".card-body");
      card.toggleClass("card-closed");
      const iframe = _findInstanceProperty(cardBody).call(cardBody, "iframe")[0];
      if (card.hasClass("card-closed")) {
        cardBody.slideDownHeight(300, () => {
          setTimeout(() => {
            this.resizeIframe(iframe);
          }, 0);
        });
      } else {
        cardBody.slideUpHeight(300);
      }
      this.resizeIframe(iframe);
    },
    toggleEmailCC() {
      this.showEmailCC = !this.showEmailCC;
    },
    replyEmail(emailId, messageId, threadId, action = "single") {
      if (!this.isCurrentUserInThread) return;
      this.$parent.$emit("change-action", "email", _objectSpread({
        action
      }, this.timelineEmail(emailId, threadId, messageId)));
    },
    async checkThreadId() {
      if (this.threadEmails.some(email => email.threadId === undefined || email.messageId === undefined || this.checkIfTempEmailId(email.id))) {
        setTimeout(() => {
          this.$parent.$emit("load-time-line");
        }, 6000);
      }
    },
    getEmailThreadTooltipTitle(createdAt) {
      return this.$options.filters.momentLocal(createdAt, "MMM. DD, YYYY LT");
    },
    async handleDelete(emailId) {
      try {
        await this.DELETE_EMAIL({
          id: this.clientProfileId,
          emailId: emailId
        });
        showToast("success", "emailDeleted");
      } catch (error) {
        Err.handle(error);
      }
    },
    getReplyTooltipText() {
      if (!this.isCurrentUserInThread) return this.$t("client-profile.messages.youCantReplyToThisThread");
      return this.$t("email.actions.reply");
    },
    openUploadFileModal(filesList, emailId) {
      if (this.checkIfTempEmailId(emailId)) return;
      this.$refs.uploadDocumentsModal.openModal();
      this.fileUploadInfo.files = filesList.files;
      this.fileUploadInfo.emailId = emailId;
    },
    handleChangeUploadInfo(event) {
      this.fileUploadInfo[event.key] = event.value;
    },
    async handleUploadDocuments() {
      var _context0;
      this.fileUploadInfo.uploading = true;
      const now = new Date().toISOString();
      const files = _mapInstanceProperty(_context0 = this.fileUploadInfo.selectedFiles).call(_context0, file => ({
        fileName: getFileName(file),
        fileId: file.id,
        createdAt: now,
        updatedAt: now,
        size: file.size,
        type: file.contentType || file.content_type
      }));
      const {
        succeeded
      } = await this.MOVE_EMAIL_ATTACHMENT({
        clientProfileId: this.clientProfileId,
        applicationId: this.fileUploadInfo.applicationId,
        emailId: this.fileUploadInfo.emailId,
        files,
        documentRequestId: this.fileUploadInfo.selectedClassification.documentRequestId || this.fileUploadInfo.selectedClassification.id,
        documentType: this.fileUploadInfo.selectedClassification.documentType
      });
      if (succeeded) for (const file of files) {
        this.ADD_TIMELINE_ITEM({
          profileId: this.clientProfileId,
          newItem: {
            activityType: "file",
            applicationId: _parseInt(this.fileUploadInfo.applicationId),
            name: file.fileName,
            classificationType: this.fileUploadInfo.selectedClassification.documentType,
            numOfComments: 0,
            createdAt: file.createdAt,
            updatedAt: file.updatedAt,
            id: file.fileId
          }
        });
      }
      this.fileUploadInfo.uploadingSucceeded = succeeded;
      this.fileUploadInfo.uploading = false;
    },
    handleResetUploadInfo() {
      this.fileUploadInfo = {
        applicationId: null,
        files: [],
        selectedFiles: [],
        selectedClassification: {},
        uploading: false,
        uploadingSucceeded: true
      };
    },
    checkIfTempEmailId(emailId) {
      return uuidValidate(emailId); //if the email id is a uuid, then is a temp email
    },
    handleCancelScheduledEmail(emailId) {
      // Use the existing delete functionality for cancelling scheduled emails
      this.handleDelete(emailId);
    }
  }),
  filters: {
    formatSendAt(val) {
      // Format the Unix timestamp correctly
      return moment.unix(val).local().format("MMM DD, YYYY LT");
    }
  }
});